import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogIndex from "../pages/blog/index";
import Article22 from "../pages/blog/article-22";
import Article23 from "../pages/blog/article-23";
import Article24 from "../pages/blog/article-24";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogIndex />,
  },
  {
    path: "/blog/how-installers-ensure-tvs-are-level-secure-and-safe",
    element: <Article22 />,
  },
  {
    path: "/blog/what-goes-into-a-high-quality-tv-installation",
    element: <Article23 />,
  },
  {
    path: "/blog/tv-installation-considerations-for-australian-homes",
    element: <Article24 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
